<script>
  import VacancyItem from './Item.svelte';

  export let title = '';
  export let items = [];
</script>

<section class="vacancy-list-wrap section-border-top">
  <div class="container">
    {#if title}
      <h3 class="h4 text-center">{@html title}</h3>
    {/if}

    <div class="vacancy-list">
      {#each items as item}
        <VacancyItem {...item} />
      {/each}
    </div>
  </div>
</section>

<style lang="scss">
  .vacancy-list {
    @include resp-min('s') {
      columns: 2;
      gap: 3.4rem;
    }

    margin: 5rem 0 0;
  }
</style>
